import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import './styles.scss';
import App from './app/App';
import { TuneddProvider } from '@brainpool/tunedd-lib';
const API_URL = import.meta.env.VITE_API_URL;
const WEBSOCKET_URL = import.meta.env.VITE_WEBSOCKET_URL;
const googleDriveClientId = import.meta.env.VITE_GOOGLE_DRIVE_CLIENT_ID;
const googleDriveApiKey = import.meta.env.VITE_GOOGLE_DRIVE_API_KEY;
const googleDriveAppId = import.meta.env.VITE_GOOGLE_DRIVE_APP_ID;

const restApiUrl = `${API_URL}/api`;
const graphQLUrl = `${API_URL}/graphql`;
const companionEndpoint = `${API_URL}/companion`;
const websockerUrl = `${WEBSOCKET_URL}/subscriptions`;
const clerkKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY!;
const productFruitsKey = import.meta.env.VITE_PRODUCT_FRUITS_WOKSPACE_CODE!;
const productFruitsNewCaseSurveyId = import.meta.env.VITE_APP_PRODUCT_FRUITS_NEW_CASE_SURVEY_ID!;

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <BrowserRouter>
      <TuneddProvider
        clerkKey={clerkKey}
        restApiUrl={restApiUrl}
        graphQLUrl={graphQLUrl}
        companionEndpoint={companionEndpoint}
        websocketUrl={websockerUrl}
        productFruitsNewCaseSurveyId={productFruitsNewCaseSurveyId}
        googleDriveClientId={googleDriveClientId}
        googleDriveApiKey={googleDriveApiKey}
        googleDriveAppId={googleDriveAppId}
      >
        <App productFruitsKey={productFruitsKey} />
      </TuneddProvider>
    </BrowserRouter>
  </StrictMode>
);
